<mat-form-field appearance="outline" class="w-100">
  @if (label()) {
    <mat-label>{{ label() }}</mat-label>
  }
  <input
    autocomplete="off"
    matInput
    [matDatepicker]="picker"
    [value]="pickerValue()"
    [min]="minDate()"
    [max]="maxDate()"
    (dateChange)="onDateChange($event)"
    (focus)="openOnFocus() ? picker.open() : null"
  />
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  @if (showFormatHint()) {
    <mat-hint>{{ dateFormat }}</mat-hint>
  }
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
